"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComboSnapshotSubsidy = getComboSnapshotSubsidy;
function getComboSnapshotSubsidy({ recommendedNegativeSubsidy, additionalSubsidy, }) {
    return recommendedNegativeSubsidy + (additionalSubsidy ?? 0);
}
//# sourceMappingURL=getComboSnapshotSubsidy.js.map